import * as ActionTypes from '../../constants/setting/blog'

export const receiveSettings = (settings) => ({
	type: ActionTypes.RECEIVE_SETTINGS,
	settings
})

export const receiveInfo = (info) => ({
	type: ActionTypes.RECEIVE_INFO,
	info
})

export const changeSloganAddress = (slogan) => ({
	type: ActionTypes.CHANGE_SLOGAN_ADDRESS,
	slogan
})

export const changeBlogVisibility = (visibility) => ({
  type: ActionTypes.CHANGE_BLOG_VISIBILITY,
  visibility
})

export const changeCustomDomain = (customDomain, certStatus, dnsFailDetected) => ({
  type: ActionTypes.CHANGE_CUSTOM_DOMAIN,
  customDomain,
  certStatus,
  dnsFailDetected
})

export const changeCertReadyStatus = (certStatus, expireDate) => ({
  type: ActionTypes.CHANGE_CUSTOM_DOMAIN_CERT_STATUS,
  certStatus,
  expireDate
})

export const changeCustomDomainDnsFail = (dnsFail) => ({
  type: ActionTypes.CHANGE_CUSTOM_DOMAIN_DNS_FAIL,
  dnsFail
})

export const deleteCustomDomain = (customDomain, useSecondaryDomain, certStatus, certExpireDate, dnsFailDetected) => ({
  type: ActionTypes.DELETE_CUSTOM_DOMAIN,
  customDomain,
  useSecondaryDomain,
  dnsFailDetected,
  certStatus,
  certExpireDate
})

export const receiveEtc = (etc) => ({
	type: ActionTypes.RECEIVE_ETC,
	etc
})

export const changeCommentRecognition = (useCommentRecognition) => ({
	type: ActionTypes.CHANGE_USE_COMMENT_RECOGNITION,
    useCommentRecognition
});

export const changeActivePlugins = (plugin) => ({
    type: ActionTypes.CHANGE_ACTIVE_PLUGINS,
    plugin
});
